import { useState, useEffect, memo } from 'react'
import { string, number, array } from 'prop-types'
import classNames from 'classnames'
import { nanoid } from 'nanoid'

import { getGalleriesArray } from '@utils/catalog'
import ArtworksGallery from './ArtworksGallery'
import { Container } from '@mch-group/uikit-components'

const mID = 'artworks-gallery-list'

const ArtworksGalleryList = memo(({
  className,
  galleryId,
  galleryName,
  galleryCleanTitle,
  id,
  linkProfile,
  sponsorGalleries,
  moreFromLabel

}) => {
  const [galleries, setGalleries] = useState([])

  useEffect(() => {
    setGalleries(getGalleriesArray(galleryId, galleryCleanTitle, galleryName, sponsorGalleries))
  }, [galleryId, galleryCleanTitle, galleryName, sponsorGalleries])

  return (
    <Container className={classNames(mID, className, 'mb-8')}>
      {galleries.map(item => (
        <ArtworksGallery
          key={nanoid()}
          {...item}
          moreFromLabel={moreFromLabel}
          id={id}
          linkProfile={linkProfile}
        />
      ))}
    </Container>
  )
})

ArtworksGalleryList.displayName = 'ArtworksGalleryList'

ArtworksGalleryList.propTypes = {
  className: string,
  galleryId: number,
  galleryName: string,
  galleryCleanTitle: string,
  linkProfile: string,
  sponsorGalleries: array,
  id: number,
  moreFromLabel: string
}

export default ArtworksGalleryList
